import { render, staticRenderFns } from "./TNetMatch.vue?vue&type=template&id=5b9afd08&scoped=true&"
import script from "./TNetMatch.vue?vue&type=script&lang=js&"
export * from "./TNetMatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9afd08",
  null
  
)

export default component.exports